import type { ContentType, Environment } from './config';

/**
 * Domain configuration for different environments
 */
export interface DomainConfig {
  caredoveDomain: string;
  searchPrefix: string;
  formsPrefix: string;
  appCaredovePrefix: string;
  protocol: string;
}

/**
 * Get domain configuration based on environment
 */
export function getDomainConfig(environment: Environment = 'prod'): DomainConfig {
  const domains: Record<Environment, DomainConfig> = {
    prod: {
      caredoveDomain: 'caredove.com',
      searchPrefix: 'search.',
      formsPrefix: 'assessment.',
      appCaredovePrefix: 'form.caredove',
      protocol: 'https://',
    },
    dev: {
      caredoveDomain: 'caredove.dev',
      searchPrefix: 'search.',
      formsPrefix: 'assessment.',
      appCaredovePrefix: 'form.caredove',
      protocol: 'https://',
    },
    stage: {
      caredoveDomain: 'caredove.io',
      searchPrefix: 'search.',
      formsPrefix: 'assessment.',
      appCaredovePrefix: 'form.caredove',
      protocol: 'https://',
    },
  };

  return domains[environment];
}

/**
 * Parsed content ID result
 */
export interface ParsedContentId {
  contentType: ContentType;
  contentId: string;
}

/**
 * URL generation parameters
 */
export interface UrlGenerationParams {
  contentType: ContentType;
  contentId: string;
  mode: string;
  subdomain?: Environment;
  parameters?: string;
  redirectUrl: string;
}

/**
 * Content type URL patterns
 */
export const CONTENT_TYPE_PATTERNS: Record<ContentType, string> = {
  'cd-searchsite': '{protocol}{searchPrefix}{subdomain}{domain}/{contentId}',
  'cd-form': '{protocol}{formsPrefix}{subdomain}{domain}/form/{folder}{contentId}',
  'cd-routing-form': '{protocol}{appPrefix}.{tld}/deploy/{contentId}',
  'cd-service': '{protocol}{searchPrefix}{subdomain}{domain}/{searchSite}/service/{serviceId}',
  'cd-request': '{protocol}{searchPrefix}{subdomain}{domain}/{searchSite}/service/{serviceId}/request',
  'url': '{contentId}',
  'url-element': 'dynamic', // Retrieved from DOM element
};
